// extracted by mini-css-extract-plugin
var _1 = "j4tPOjltTrwbI529PoT6";
var _2 = "pBl9NkdQnE_nRZhHnHwo";
export { _1 as "container", _2 as "healthbar" }
